import { render, staticRenderFns } from "./serveyRecordList.vue?vue&type=template&id=17b2cd18&"
import script from "./serveyRecordList.vue?vue&type=script&lang=js&"
export * from "./serveyRecordList.vue?vue&type=script&lang=js&"
import style0 from "./serveyRecordList.vue?vue&type=style&index=0&id=17b2cd18&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports